var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSales(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.871,
    height: 20.871,
    viewBox: "0 0 20.871 20.871",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-409.73 -290.106)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M420.166,290.106A10.436,10.436,0,1,0,430.6,300.542,10.448,10.448,0,0,0,420.166,290.106Zm0,19.47a9.035,9.035,0,1,1,9.035-9.034A9.046,9.046,0,0,1,420.166,309.576Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M421.34,295.241a5.308,5.308,0,0,1,1.707.286.7.7,0,1,0,.453-1.324,6.68,6.68,0,0,0-8.662,4.748h-1.287a.7.7,0,0,0,0,1.4h1.1c0,.063-.01.125-.01.189a6.69,6.69,0,0,0,.109,1.166h-1.2a.7.7,0,0,0,0,1.4h1.6a6.683,6.683,0,0,0,8.348,3.773.7.7,0,1,0-.453-1.324,5.248,5.248,0,0,1-6.316-2.449h4.417a.7.7,0,0,0,0-1.4h-4.97a5.269,5.269,0,0,1-.138-1.166c0-.065.016-.125.019-.189h5.891a.7.7,0,0,0,0-1.4h-5.64A5.289,5.289,0,0,1,421.34,295.241Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSales);
export default __webpack_public_path__ + "static/media/sales.7361d4454a6af6e7b5d6b02a0fec85b6.svg";
export { ForwardRef as ReactComponent };